import {
  faBars,
  faCircleUser,
} from "@fortawesome/free-solid-svg-icons"
import { useContext } from "react"
import { LayoutContext } from "../context"
import { linksUrl } from "../constants/enum"
import { useNavigate } from "react-router-dom"
import { setLogout } from "../state/authSlice"
import { useDispatch, useSelector } from "react-redux"
import { resetUserMaster } from "../state/userMasterSlice"
import { resetAdminMaster } from "../state/adminMasterSlice"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { resetClientMaster } from "../state/clientMasterSlice"
import { 
  Button,
  Navbar,
  NavbarBrand,
  NavbarContent,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react"

function NavBar() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setShowSideNav } = useContext(LayoutContext)
  const { currentAdmin } = useSelector((state) => state.auth)

  const handleLogout = () => { 
    dispatch(setLogout())
    dispatch(resetAdminMaster())
    dispatch(resetClientMaster())
    dispatch(resetUserMaster())
    navigate(linksUrl.login)
  }

  return (
    <div> 
      <Navbar isBordered className="z-[99] sticky">
        <NavbarContent justify="start">
          <NavbarBrand className="mr-4 flex items-center gap-2">
            <Button
              variant="light"
              isIconOnly
              aria-label="Like"
              className=""
              size="sm"
              onClick={() => {
                setShowSideNav((prev) => !prev)
              }}
            >
              <FontAwesomeIcon icon={faBars} size="xl" />
            </Button>
            <p className="font-bold text-inherit">WINAPP-ADMIN</p> 
          </NavbarBrand>
        </NavbarContent>

        <NavbarContent as="div" className="items-center" justify="end">
          <Dropdown placement="bottom-end" className="">
            <DropdownTrigger>
              <FontAwesomeIcon icon={faCircleUser} size="xl" />
            </DropdownTrigger>
            <DropdownMenu aria-label="Profile Actions" variant="flat">
              <DropdownItem key="profile" className="h-14 gap-2">
                <p className="">Signed in as</p>
                <p className="font-semibold">{currentAdmin?.username}</p>
              </DropdownItem>
              <DropdownItem key="logout" color="danger" onClick={handleLogout}>
                Log Out
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </NavbarContent>
      </Navbar>
    </div>
  )
}

export default NavBar
